import type { CSSVariablesResolver } from "@mantine/core";
import { MantineFormCssResolver } from "@ngt-form/mantine";

export const mantineCssResolver: CSSVariablesResolver = (theme) => {
    const resolver = MantineFormCssResolver(theme);

    resolver.light["--mantine-color-disabled-color"] = "var(--mantine-color-text)";
    resolver.dark["--mantine-color-disabled-color"] = "var(--mantine-color-text)";

    return resolver;
};
